// extracted by mini-css-extract-plugin
export default {"modal_overlay":"ui_modal_overlay__n1G7w","modal_content":"ui_modal_content__ZLU-I","buttons":"ui_buttons__jf5u1"};